"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThankyouComponent = /** @class */ (function () {
    function ThankyouComponent() {
    }
    return ThankyouComponent;
}());
exports.ThankyouComponent = ThankyouComponent;
